import { Utility, utility_controller } from '../utility/utility_controller'
import showhide_onscroll_controller from '../showhide_onscroll/showhide_onscroll_controller'

var mobile_menu_controller = {
	i: function () {
		if (layData.mobile_menu_style != 'style_desktop_menu' && layData.mobile_menu_style != 'pill_menu_style' && layData.mobile_menu_style != 'button_menu_style') {
			i()
		}
	},
	hideMenu: function () {
		if (layData.mobile_menu_style != 'style_desktop_menu' && layData.mobile_menu_style != 'pill_menu_style' && layData.mobile_menu_style != 'button_menu_style') {
			hideMenu()
		}
	},
	hideMobileMenu: function () {
		if (layData.mobile_menu_style != 'style_desktop_menu' && layData.mobile_menu_style != 'pill_menu_style' && layData.mobile_menu_style != 'button_menu_style') {
			hideMobileMenu()
		}
	},
}
window.mobile_menu_controller = mobile_menu_controller

export default mobile_menu_controller

var stateMap = {
		wWidth: window.innerWidth,
		oldInnerWidth: window.innerWidth,
		isOpen: false,
	},
	jqueryMap = {
		$nav: null,
		$navul: null,
		$burger: null,
	}

var bindIconClicks = function () {
	jQuery('.lay-mobile-icons-wrap').on('click', function (event) {
		if (jQuery(event.target).closest('.burger-wrap, .lay-cart-icon-wrap, .lay-mobile-menu-optional-content').length > 0) {
			return
		}
		doBurgerToggle()
	})

	switch (layData.mobile_burger_type) {
		case 'default':
		case 'default_thin':
			jQuery('.burger-wrap-default').on('click', doBurgerToggle)
			break
		case 'new':
			jQuery('.burger-wrap-new').on('click', doBurgerToggle)
			break
		case 'custom':
			jQuery('.burger-custom-wrap-close').on('click', function () {
				if (jqueryMap.$nav.hasClass('active')) {
					hideMenu()
				}
			})
			jQuery('.burger-custom-wrap-open').on('click', function () {
				if (!jqueryMap.$nav.hasClass('active')) {
					showMenu()
				}
			})
			break
		case 'text':
			jQuery('.burger-wrap-text').on('click', doBurgerToggle)
			break
	}
}

var showMenu = function () {
	// scroll container to top
	jQuery('.mobile-nav').scrollTop(0)
	jqueryMap.$nav.addClass('active')
	jQuery('body').addClass('mobile-menu-open').removeClass('lay-hide-phone-menu')
	stateMap.isOpen = true
	if (typeof window.layDevModeEmit === 'function' && jqueryMap.$nav && jqueryMap.$nav[0]) {
		window.layDevModeEmit('mobile_menu:opened', jqueryMap.$nav[0])
	}

	if (jQuery('.burger-wrap-text').length > 0) {
		if (layData.mobile_menu_style === 'style_2') {
			// Only update the close button inside the panel; keep header burger as "Menu"
			jQuery('nav.mobile-nav .burger-wrap-text').text(jQuery('nav.mobile-nav .burger-wrap-text').data('text-close'))
		} else {
			jQuery('.burger-wrap-text').text(jQuery('.burger-wrap-text').data('text-close'))
		}
	}

	switch (layData.mobile_menu_style) {
		case 'style_1':
			var navbarH = getNavbarHeight()
			jQuery('body').addClass('animate-mobile-menu')
			jqueryMap.$nav.off('transitionend').on('transitionend', function () {
				jQuery('body').removeClass('animate-mobile-menu')
			})
			jqueryMap.$nav.css({
				transform: 'translateY(' + navbarH + 'px)',
				'-webkit-transform': 'translateY(' + navbarH + 'px)',
				top: 0,
			})
			break
		case 'style_2':
			break
		case 'style_3':
			var navbarH = getNavbarHeight()
			var top = navbarH
			jqueryMap.$nav.css({
				height: 'calc(' + window.innerHeight + 'px - ' + navbarH + 'px)',
				top: top + 'px',
			})
			break
		case 'style_4':
			var navbarH = getNavbarHeight()
			var top = navbarH
			jQuery('body').addClass('animate-mobile-menu')
			jqueryMap.$nav.off('transitionend').on('transitionend', function () {
				jQuery('body').removeClass('animate-mobile-menu')
			})
			jqueryMap.$nav.css({
				height: 'calc(' + window.innerHeight + 'px - ' + navbarH + 'px)',
				top: top + 'px',
				transform: 'translateY(0)',
				'-webkit-transform': 'translateY(0)',
			})
			break
	}
	if (layData.mobile_menu_disable_body_scroll == '1') {
		utility_controller.fixBodyAlt()
	}
}

var doBurgerToggle = function () {
	if (!jqueryMap.$nav.hasClass('active')) {
		switch (layData.mobile_burger_type) {
			case 'new':
			case 'default':
			case 'default_thin':
				if (layData.mobile_menu_style != 'style_2') {
					jqueryMap.$burger.addClass('active')
				}
				break
		}
		showMenu()
	} else {
		hideMenu()
	}
}

var bindWindowResize = function () {
	jQuery(window).on('resize orientationchange', function () {
		stateMap.oldInnerWidth = stateMap.wWidth
		stateMap.wWidth = window.innerWidth
		if (window.innerWidth > Utility.phoneMenuBreakpoint) {
			if (stateMap.oldInnerWidth <= Utility.phoneMenuBreakpoint) {
				resetMobileMenuMaxHeight()
				// just switched from phone view to desktop view
				jqueryMap.$nav.css({
					transform: '',
					'-webkit-transform': '',
				})
				jqueryMap.$nav.removeClass('active transition')
				if (layData.mobile_menu_style != 'style_2') {
					jqueryMap.$burger.removeClass('active')
				}
				jQuery('body').removeClass('mobile-menu-open')
			}
		} else {
			// just switched from desktop view to phone view
			if (stateMap.oldInnerWidth > Utility.phoneMenuBreakpoint) {
				if (!jqueryMap.$nav.hasClass('active')) {
					hideMenu({ noTransition: true })
				}
				showhide_onscroll_controller.showAll()
			}

			setMobileMenuMaxHeight()
		}
	})
}

// to make menu scrollable
var setMobileMenuMaxHeight = function () {
	if (window.innerWidth <= Utility.phoneMenuBreakpoint) {
		switch (layData.mobile_menu_style) {
			case 'style_4':
			case 'style_1':
				var navbarH = getNavbarHeight()
				var h = window.innerHeight - navbarH
				jqueryMap.$nav.css('max-height', h + 'px')
				break
			case 'style_2':
				var h = window.innerHeight
				jqueryMap.$nav.css('max-height', h + 'px')
				break
		}
	}
}

var getNavbarHeight = function () {
	var navbarH = 0
	if (layData.mobile_hide_menubar != '1') {
		var rect = jQuery('.navbar')[0].getBoundingClientRect()
		// + rect.top  in case we have a woocommerce store notice
		navbarH = rect.height + rect.top
	}
	return navbarH
}

var resetMobileMenuMaxHeight = function () {
	if (window.innerWidth > Utility.phoneMenuBreakpoint) {
		jqueryMap.$nav.css('max-height', '')
	}
}

var hideMenu = function (options) {
	if (typeof window.layDevModeEmit === 'function' && jqueryMap && jqueryMap.$nav && jqueryMap.$nav[0]) {
		window.layDevModeEmit('mobile_menu:closed', jqueryMap.$nav[0])
	}
	if (jQuery('.burger-wrap-text').length > 0) {
		if (layData.mobile_menu_style === 'style_2') {
			jQuery('.lay-mobile-icons-wrap .burger-wrap-text').text(jQuery('.lay-mobile-icons-wrap .burger-wrap-text').data('text-open'))
		} else {
			jQuery('.burger-wrap-text').text(jQuery('.burger-wrap-text').data('text-open'))
		}
	}

	stateMap.isOpen = false
	if (window.innerWidth < Utility.phoneMenuBreakpoint) {
		hideMobileMenu(options)
	} else {
		if (layData.mobile_menu_disable_body_scroll == '1') {
			utility_controller.unfixBody()
		}
		if (layData.mobile_menu_style != 'style_2') {
			jqueryMap.$burger.removeClass('active')
		}
		jQuery('body').removeClass('mobile-menu-open')
		jqueryMap.$nav.removeClass('active').css({
			transform: '',
			'-webkit-transform': '',
		})
	}
}

var hideMobileMenu = function (options) {
	if (window.innerWidth < Utility.phoneMenuBreakpoint) {
		if (layData.mobile_menu_disable_body_scroll == '1') {
			utility_controller.unfixBody()
		}

		stateMap.isOpen = false
		jqueryMap.$nav.removeClass('active')
		jQuery('body').removeClass('mobile-menu-open')
		if (layData.mobile_menu_style != 'style_2') {
			jqueryMap.$burger.removeClass('active')
		}
		switch (layData.mobile_menu_style) {
			case 'style_1':
				var top = jqueryMap.$navul.outerHeight()
				top *= -1

				var $navbar = jQuery('.navbar')
				var navh = $navbar.length ? $navbar.outerHeight() : 0

				top -= navh
				if (options && options.noTransition) {
				} else {
					jQuery('body').addClass('animate-mobile-menu')
					jqueryMap.$nav.off('transitionend').on('transitionend', function () {
						jQuery('body').removeClass('animate-mobile-menu')
					})
				}

				jqueryMap.$nav.css({
					transform: 'translateY(' + top + 'px)',
					'-webkit-transform': 'translateY(' + top + 'px)',
				})
				break
			case 'style_4':
				var top = jqueryMap.$navul.outerHeight()
				top *= -1

				var $navbar = jQuery('.navbar')
				var navh = $navbar.length ? $navbar.outerHeight() : 0

				top -= navh

				if (options && options.noTransition) {
				} else {
					jQuery('body').addClass('animate-mobile-menu')
					jqueryMap.$nav.off('transitionend').on('transitionend', function () {
						jQuery('body').removeClass('animate-mobile-menu')
					})
				}
				jqueryMap.$nav.css({
					transform: 'translateY(calc(-100% - ' + navh + 'px))',
					'-webkit-transform': 'translateY(calc(-100% - ' + navh + 'px))',
				})
				break
			case 'style_2':
				if (options && options.noTransition) {
				} else {
					jQuery('body').addClass('animate-mobile-menu')
					jqueryMap.$nav.off('transitionend').on('transitionend', function () {
						jQuery('body').removeClass('animate-mobile-menu')
					})
				}
				break
			case 'style_3':
				jQuery('body').addClass('animate-mobile-menu')
				jqueryMap.$nav.off('transitionend').on('transitionend', function () {
					jQuery('body').removeClass('animate-mobile-menu')
				})
				jqueryMap.$nav.css({
					height: '',
				})
				break
		}
		if (jQuery('.burger-wrap-text').length > 0) {
			if (layData.mobile_menu_style === 'style_2') {
				jQuery('.lay-mobile-icons-wrap .burger-wrap-text').text(jQuery('.lay-mobile-icons-wrap .burger-wrap-text').data('text-open'))
			} else {
				jQuery('.burger-wrap-text').text(jQuery('.burger-wrap-text').data('text-open'))
			}
		}
	}
}

var setjQueryMap = function () {
	jqueryMap.$nav = jQuery('nav.mobile-nav')
	jqueryMap.$navul = jqueryMap.$nav.find('ul')
	jqueryMap.$burger = jQuery('.burger-default, .burger-new')
}

var preventAnchorDrag = function () {
	jQuery('nav.mobile-nav a').on('dragstart', function (ev) {
		ev.preventDefault()
	})
}

var $notice, $mobilenav, $navbar

var bindScroll = function () {
	if (layData.mobile_navbar_fixed == '') {
		return
	}
	$notice = jQuery('.woocommerce-store-notice')
	$mobilenav = jQuery('.mobile-nav')
	$navbar = jQuery('.navbar')
	switch (layData.mobile_menu_style) {
		case 'style_4':
		case 'style_1':
			if ($notice.length > 0 && $mobilenav.length > 0 && $navbar.length > 0) {
				window.eventsChannel.on('scroll', function (scrollTop, scrollHeight, scrollContext) {
					if (scrollContext && scrollContext.source === 'page-overlay') {
						return
					}
					if (stateMap.isOpen) {
						// var noticeRect = $notice[0].getBoundingClientRect();
						// var mobileNavRect = $mobilenav[0].getBoundingClientRect();
						var navbarRect = $navbar[0].getBoundingClientRect()

						var diff = navbarRect.bottom
						// if( diff >= noticeRect.height ) {
						// 	diff = mobileNavRect.height
						// }

						// var diff = $mobilenav[0].getBoundingClientRect().height + rect.height
						// if( scrollTop <= noticeRect.height ) {
						// diff = $mobilenav[0].getBoundingClientRect().height + rect.height
						// }

						$mobilenav.css('transform', 'translateY(' + diff + 'px)')
					}
				})
			}
			break
		case 'style_2':
			break
		case 'style_3':
			if ($notice.length > 0 && $mobilenav.length > 0) {
				window.eventsChannel.on('scroll', function (scrollTop, scrollHeight, scrollContext) {
					if (scrollContext && scrollContext.source === 'page-overlay') {
						return
					}
					var rect = $notice[0].getBoundingClientRect()
					var diff = scrollTop
					if (diff >= rect.height) {
						diff = rect.height
					}

					$mobilenav.css('transform', 'translateY(-' + diff + 'px)')
				})
			}
			break
	}
}

var i = function () {
	preventAnchorDrag()
	setjQueryMap()
	bindScroll()

	bindWindowResize()
	bindIconClicks()
	setMobileMenuMaxHeight()

	WebFont.load({
		custom: {
			families: layData.m_st_fontfamily,
		},
		active: function () {
			// hide mobile menu again after webfonts have loaded, because menupoints ul height might have changed

			hideMobileMenu()
		},
		classes: false,
	})
	// i call hidemobilemenu here just to position it mobilemenus correctly
	// afterwards it can get the animation class to be able to have transitions
	hideMobileMenu()
	setTimeout(function () {
		jQuery('body').addClass('mobile-menu-animation-possible')
	}, 0)

	// bind hiding the menu to newpageshown so body classes are updated before we compute transforms
	// only do it after the first newpageshown and newpage even have fired (timeout)
	jQuery(document).ready(function () {
		setTimeout(function () {
			window.laytheme.on('newpageshown', hideMobileMenu)
			// but also hide mobile menu on history change
			window.laytheme.on('newpage', hideMobileMenu)
		}, 100)
	})
	window.laytheme.on('searchshown', hideMobileMenu)
}
